// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Side-menu */
.img-sm {
  width: 120px;
  height: 80px;
  display: block;
  margin: 0 auto;
}

.mainnav-profile .profile-wrap {
  background-image: none;
  padding: 30px 20px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

#mainnav-menu {
  margin-top: 20px !important;
}

a.nav-item svg {
  height: 32px;
  width: 32px;
  margin-right: 20px;
}

#mainnav-menu > li a svg * {
  fill: #808080 !important;
  transition: fill 0.5s ease;
}

#mainnav-menu > li > a:hover svg *,
#mainnav-menu > li > a:active svg *,
#mainnav-menu > li a.boletos-nav:not(.collapsed) svg * {
  fill: #29b2ee !important;
}

#mainnav-menu > .active-link > a svg *,
#mainnav-menu > .active-link > a:hover svg *,
#mainnav-menu > .active-link > a.boletos-nav:not(.collapsed) svg *,
#mainnav-menu > .active-link > a.boletos-nav:not(.collapsed):hover svg * {
  fill: #4379ff !important;
}

@media (max-width: 767px) {
  #mainnav-container {
    padding-top: 0;
  }
}
a.list-group-item svg {
  height: 32px;
  width: 32px;
  margin-right: 20px;
}

/* main nav profile */
#mainnav .mainnav-profile .list-group-item {
  color: #808080;
}

#mainnav .mainnav-profile .list-group-item:hover {
  color: #aa70ff;
  box-shadow: inset 2px 0 0 0 #aa70ff;
}

#profile-nav > a.active-link,
#profile-nav > a.active-link:hover {
  color: #7f47d1 !important;
  box-shadow: inset 2px 0 0 0 #7f47d1 !important;
}

#profile-nav > a svg * {
  fill: #808080 !important;
}

#profile-nav > a:hover svg *,
#profile-nav > a:active svg * {
  fill: #aa70ff !important;
}

#profile-nav > a.active-link svg *,
#profile- > a.active-link:hover svg * {
  fill: #7f47d1 !important;
}

#profile-nav .list-group-item {
  border: none;
}

/* caret */
.ti-angle-down {
  display: inline-block;
  position: relative;
  top: -8px;
  left: 10px;
}

a .ti-angle-down {
  transition: transform 0.25s ease;
  transform: rotate(-180deg);
}

a.collapsed .ti-angle-down {
  transform: rotate(0deg);
}

#boletos-nav {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  background-color: #f7f7f7;
  margin: 0;
}
#boletos-nav .menu-title {
  top: 0;
}
#boletos-nav a.active-link {
  color: #4379ff;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/dashboard/components/side-menu/side-menu.component.scss","webpack://./src/sass/_variables.scss"],"names":[],"mappings":"AAEA,cAAA;AAEA;EACI,YAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AAFJ;;AAKA;EACI,sBAAA;EACA,uBAAA;EACA,4CAAA;AAFJ;;AAKA;EACI,2BAAA;AAFJ;;AAKA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,wBAAA;EACA,0BAAA;AAFJ;;AAKA;;;EAGI,wBAAA;AAFJ;;AAKA;;;;EAII,wBAAA;AAFJ;;AAKA;EACI;IACI,cAAA;EAFN;AACF;AAKA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;AAHJ;;AAMA,qBAAA;AAEA;EACI,cAAA;AAJJ;;AAOA;EACI,cAAA;EACA,mCAAA;AAJJ;;AAOA;;EAEI,yBAAA;EACA,8CAAA;AAJJ;;AAOA;EACI,wBAAA;AAJJ;;AAOA;;EAEI,wBAAA;AAJJ;;AAOA;;EAEI,wBAAA;AAJJ;;AAOA;EACI,YAAA;AAJJ;;AAOA,UAAA;AAEA;EACI,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AALJ;;AAQA;EACI,gCAAA;EACA,0BAAA;AALJ;;AAQA;EACI,uBAAA;AALJ;;AAQA;EAOI,wCAAA;EACA,2CAAA;EACA,yBC/FgB;EDgGhB,SAAA;AAXJ;AAEI;EACI,MAAA;AAAR;AAEI;EACI,cAAA;AAAR","sourcesContent":["@import '../../../../../sass/variables';\n\n/* Side-menu */\n\n.img-sm {\n    width: 120px;\n    height: 80px;\n    display: block;\n    margin: 0 auto;\n}\n\n.mainnav-profile .profile-wrap {\n    background-image: none;\n    padding: 30px 20px 20px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n#mainnav-menu {\n    margin-top: 20px !important;\n}\n\na.nav-item svg {\n    height: 32px;\n    width: 32px;\n    margin-right: 20px;\n}\n\n#mainnav-menu>li a svg * {\n    fill: #808080 !important;\n    transition: fill 0.5s ease;\n}\n\n#mainnav-menu>li>a:hover svg *,\n#mainnav-menu>li>a:active svg *,\n#mainnav-menu>li a.boletos-nav:not(.collapsed) svg * {\n    fill: #29b2ee !important;\n}\n\n#mainnav-menu>.active-link>a svg *,\n#mainnav-menu>.active-link>a:hover svg *,\n#mainnav-menu>.active-link>a.boletos-nav:not(.collapsed) svg *,\n#mainnav-menu>.active-link>a.boletos-nav:not(.collapsed):hover svg * {\n    fill: #4379ff !important;\n}\n\n@media (max-width: 767px) {\n    #mainnav-container {\n        padding-top: 0;\n    }\n}\n\na.list-group-item svg {\n    height: 32px;\n    width: 32px;\n    margin-right: 20px;\n}\n\n/* main nav profile */\n\n#mainnav .mainnav-profile .list-group-item {\n    color: #808080;\n}\n\n#mainnav .mainnav-profile .list-group-item:hover {\n    color: #aa70ff;\n    box-shadow: inset 2px 0 0 0 #aa70ff;\n}\n\n#profile-nav>a.active-link,\n#profile-nav>a.active-link:hover {\n    color: #7f47d1 !important;\n    box-shadow: inset 2px 0 0 0 #7f47d1 !important;\n}\n\n#profile-nav>a svg * {\n    fill: #808080 !important;\n}\n\n#profile-nav>a:hover svg *,\n#profile-nav>a:active svg * {\n    fill: #aa70ff !important;\n}\n\n#profile-nav>a.active-link svg *,\n#profile->a.active-link:hover svg * {\n    fill: #7f47d1 !important;\n}\n\n#profile-nav .list-group-item {\n    border: none;\n}\n\n/* caret */\n\n.ti-angle-down {\n    display: inline-block;\n    position: relative;\n    top: -8px;\n    left: 10px;\n}\n\na .ti-angle-down {\n    transition: transform .25s ease;\n    transform: rotate(-180deg);\n}\n\na.collapsed .ti-angle-down {\n    transform: rotate(0deg);\n}\n\n#boletos-nav {\n    .menu-title {\n        top: 0;\n    }\n    a.active-link {\n        color: #4379ff;\n    }\n    border-top: 1px solid rgba(0,0,0,0.1);\n    border-bottom: 1px solid rgba(0,0,0,0.1);\n    background-color: $background-common;\n    margin: 0;\n}","// -------\n// Paleta de Cores\n// -------\n\n// Cores da Identidade - Listadas com base no gradiente principal\n\n$azul-200: #00f6ff;\n$azul-300: #00caff;\n$azul-400: #22b7ff;\n$azul-500: #4379ff;\n$violeta: #6a5cff;\n$roxo-500: #8e42ff;\n$roxo-400: #a42cff;\n$roxo-300: #a900ff;\n\n// Tons neutros \n\n$cinza-600: #777777;     //textos \"on\" - textos principais\n$cinza-500: #999999;     //textos \"off\" - textos auxiliares\n$cinza-400: #cccccc;      \n$cinza-300: #e2e2e2;     //bordas - menos vivo que o texto off\n$cinza-200: #e6e6e6;     //Para bullet points, e etc.\n$cinza-100: #ececec;     //tom mais claro de cinza após o background\n\n$background-common: #f7f7f7;\n$white: #fff;\n\n// Cores padrões\n\n$primary: $violeta;\n$secondary: $cinza-200;\n$success: $azul-500;\n$info: $azul-400;\n$warning: #edaf80;\n$danger: #e57373;\n$inverse: $cinza-500;\n\n\n//fontes - variáveis\n\n$fonte-pague-la: \"Pague.la\", \"Open Sans\", sans-serif;\n$fonte-open-sans: \"Open Sans\", sans-serif;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
